import Category from "./components/Category";
import Pages from "./pages/pages";
import { BrowserRouter, Link } from "react-router-dom";
import Search from "./components/Search";
import styled from "styled-components";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Logo to={"/"}>
          <img src="/logo.png" alt="logo" />
        </Logo>
        <Search />
        <Category />
        <Pages />
      </BrowserRouter>
    </div>
  );
}

const Logo = styled(Link)`
  position: absolute;
  top: 0px;
  left: 50px;
  width: 130px;
  height: 130px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media screen and (max-width: 700px) {
    left: 10px;
    width: 80px;
    height: 80px;
  }
`;
export default App;
